<!-- 彩生活新增月卡接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KNRNIJC",
    "carNo": "粤Y12345",
    "beginDate": "2018-11-01 00:00:00",
    "endDate": "2018-12-01 00:00:00",
    "monthFeeRuleCode": "0001",
    "monthFeeValue": 10.5,
    "carCodeArray": [
        "粤Y12345"
    ],
    "numbers": "1"
                },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台新增月卡（二）接口",
                t_url: this.commonUrls.test+"monthFeeNew",
                p_url: this.commonUrls.prod+"monthFeeNew",
                precondition: "无",
                fitSystem: "VEMS传统停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码与车牌号码列表二选一' },
                        { info1: 'beginDate', info2: '是', info3: 'String', info4: '起始时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'endDate', info2: '是', info3: 'String', info4: '结束时间，yyyy-MM-dd HH:mm:ss' },
                        { info1: 'monthFeeRuleCode', info2: '是', info3: 'String', info4: '规则编号' },
                        { info1: 'monthFeeValue', info2: '是', info3: 'Decimal', info4: '月卡单价' },
                        { info1: 'carCodeArray', info2: '否', info3: 'String[]', info4: '车牌号码与车牌号码列表二选一' },
                        { info1: 'numbers', info2: '否', info3: 'String', info4: '车位数' },

                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/vip/monthFeeNew.vue